<template>
  <div class="page-sign-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">客服專區</div>
      <div class="breadcrumb-item">未簽收(全部)</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
            size="small"
            placeholder="提貨櫃點"
            @on-change="handleStoreChange(form.arrive)"
            v-model="form.arrive"
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAddress"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="貨架號"
            v-model="form.shelves"
            ref="resetSelect"
            clearable
          >
            <Option
              :value="item.id"
              v-for="(item, index) in pickShelves"
              :key="item.id"
              >{{ item.code }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select size="small" placeholder="操作人" v-model="form.admin_id">
            <Option
              :value="item.user_id"
              v-for="(item, index) in pickAdmin"
              :key="item.user_id"
              >{{ item.username }} ({{ item.realname }})
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="付款狀況"
            v-model="form.pay_type"
            ref="resetSelect"
            clearable
          >
            <Option value="0">未在APP內付款</Option>
            <Option value="1">已在APP內付款</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="到店起始日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            :editable="false"
            v-model="form.start_time"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="到店結束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            :editable="false"
            v-model="form.end_time"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
            size="small"
            clearable
            v-model="form.odd_numbers"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
            size="small"
            clearable
            v-model="form.username"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input
            size="small"
            clearable
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input
            size="small"
            clearable
            v-model="form.sack_number"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <!-- <div class="pg-btn style2" @click="handleExport">導出excel</div> -->
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        ref="table"
        size="small"
        border
        height="700"
        no-data-text="暫無數據"
        @on-selection-change="handleSelectionChange"
        :columns="table.column"
        :data="table.data"
      >
        <!-- <template slot-scope="{ row, index }" slot="avatar">
            <div class="avatar-box">
                <img :src="row.avatar" alt="">
            </div>
        </template> -->
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style3" @click="handleViewWuliu(index)">
              物流
            </div>
            <div
              class="pg-btn style2"
              @click="handleEdit(index)"
              v-if="account_permission == 1"
            >
              修改
            </div>
            <div
              class="pg-btn style1"
              @click="handleViewRemark(index)"
              v-if="account_permission == 1"
            >
              備註
            </div>
            <div class="pg-btn style1" @click="handleFees(row, index)">
              追加费用
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
            <span style="padding: 0 12px">件数：{{ sums }}</span>
            <span style="padding: 0 12px">重量：{{ weight }}</span>
            <span>总价格：{{ price }}</span>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                  <Option :value="100">100</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <FeesCom
      :isShowModal="isShowModal"
      @modalSubmit="modalSubmit"
      @modalCancel="modalCancel"
      @modalStatusChange="modalStatusChange"
    ></FeesCom>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";
import FeesCom from "./FeesCom";

let isthis;
export default {
  components: { FeesCom },
  data() {
    return {
      successAudio: "music-success.mp3", //成功音效
      errorAudio: "music-fail.mp3", //失敗音效
      pageIndex: 1, //頁碼
      curPageSize: 10, //一頁數量
      totalCount: 1, //總條數
      pageInput: "", //輸入的頁碼
      pickAddress: [], //提貨櫃點
      pickShelves: [], //貨架號
      pickAdmin: [],
      account_permission: Store.fetch().type,
      form: {
        arrive: "", //提貨櫃點id
        start_time: "", //起始日期
        end_time: "", //結束日期
        odd_numbers: "", //快遞單號
        phone: "", //電話號碼
        sack_number: "", //袋號
        shelves: "", //貨架號
        username: "", //用户名稱
        pay_type: "",
        admin_id: "",
      },
      activity: "",
      outtimepay: "",
      pay_type: "",
      sums: 0,
      weight: 0,
      price: 0,
      isSubmiting: false,
      infoSubmiting: false,
      checkOutTimePay: false,
      additional: "", // 附加費
      checkAdditional: false,
      checkOutDelivery: false,
      table: {
        column: [
          {
            type: "selection",
            width: 60,
            align: "center",
            fixed: "left",
          },
          {
            title: "操作",
            slot: "action",
            align: "center",
            width: 300,
            fixed: "left",
          },
	        {
		        title: "備註",
		        key: "remarks",
		        align: "center",
		        sortable: true,
		        minWidth: 160,
	        },
          {
            title: "上架天數",
            key: "save_time",
            align: "center",
            minWidth: 100,
            sortable: true,
          },
          {
            title: "客戶名稱【積分】",
            key: "recipient_contacts",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "客戶電話",
            key: "recipient_phone",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "出貨單號",
            key: "odd_numbers",
            align: "center",
            minWidth: 150,
            sortable: true,
          },
          {
            title: "付款狀況",
            key: "pay_type",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "貨架號",
            key: "shelves",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "代收費",
            key: "amount",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name",
          },
          {
            title: "到付運費",
            key: "freight_collect",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name",
          },
          {
            title: "加收附加費",
            key: "surcharge_price",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name",
          },
          {
            title: "超期費",
            key: "outtimepay",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name",
          },
          {
            title: "門店立減費",
            key: "activity",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name",
          },
          {
            title: "合計費用",
            key: "sum",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-cell-name-sum",
          },
          {
            title: "重量",
            key: "weight",
            align: "center",
            sortable: true,
            minWidth: 70,
          },
          /*{
            title: '泡重',
            key: 'volume_weight',
            align: 'center',
            sortable: true,
            minWidth: 70
          },*/
          {
            title: "取貨櫃點",
            key: "receivingName",
            align: "center",
            minWidth: 150,
          },
          {
            title: "珠海倉庫(入庫時間)",
            key: "in_time",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "珠海倉庫(出庫時間)",
            key: "out_time",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "澳門門店/智能櫃(上架時間)",
            key: "arrive_time",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "澳門門店/智能櫃(簽收時間)",
            key: "pick_time",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "袋號",
            key: "sack_number",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          
          {
            title: "品名",
            key: "productName",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "珠海倉庫(出庫員工)",
            key: "admininfo",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
        ],
        data: [],
      },
      isShowModalSign: false, //收款并签收信息
      curCheckedList: [], //当前选中的数据
      signInfo: {},

      isPaying: false,
      modalForm: {
        delivery: {
          isChecked: true,
        },
        jifen: {
          value: 0,
          isChecked: true,
        },
        cash: {
          value: 0,
          isChecked: false,
        },
        aomentong: {
          value: 0,
          isChecked: false,
        },
        mPay: {
          value: 0,
          isChecked: false,
        },
        zyPos: {
          value: 0,
          isChecked: false,
        },
        gyPos: {
          value: 0,
          isChecked: false,
        },
        alipay: {
          value: 0,
          isChecked: false,
        },
        wxpay: {
          value: 0,
          isChecked: false,
        },
      },
      isShowModal: false, // 追加费用
      feesOddNumber: "",
    };
  },
  created() {
    isthis = this;
    this.getPickAddress();
    this.getShelvesList();
    this.getPickAdmin();
  },
  mounted() {
    this.getList();
  },
  activated() {
    isthis = this;
    this.getPickAddress();
    this.getShelvesList();
    this.getPickAdmin();
    this.getList();
  },
  methods: {
    modalSubmit(row) {
      this.$Rq
        .requestAuth({
          url: this.$Api.feesAddPrice,
          method: "post",
          data: {
            odd_numbers: this.feesOddNumber,
            pay_name: row.name,
            amount: row.sum,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
            this.getList();
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.$Utils.showTipInfo("网络异常");
        });
      this.isShowModal = false;
      this.feesOddNumber = "";
    },
    // 模态框取消事件
    modalCancel() {
      this.isShowModal = false;
      this.feesOddNumber = "";
    },
    // 模态框关闭触发事件
    modalStatusChange(e) {
      if (!e) {
        this.isShowModal = false;
        this.feesOddNumber = "";
      }
    },
    // 追加费用
    handleFees(row, index) {
      console.log(row);
      this.feesOddNumber = row.odd_numbers;
      this.isShowModal = true;
    },
    formatDate(datetime) {
      if (!datetime) return "";
      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    getPickAdmin() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAdmin,
          method: "post",
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAdmin = res.data.data;
          }
        });
    },
    getPickAddress() { //提貨櫃點
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
            if (res.data.data.length <= 1) {
              this.form.arrive = res.data.data[0].ReceivingID;
            }
          }
        });
    },
    getShelvesList(
      list //貨架號
    ) {
      if (list > 0) {
        this.$Rq
          .requestAuth({
            url: this.$Api.shelvesAllList,
            method: "get",
            data: {
              store_id: list,
            },
          })
          .then((res) => {
            if (res.code == 0) {
              this.pickShelves = res.data;
            }
          });
      } else {
        this.$Rq
          .requestAuth({
            url: this.$Api.shelvesAllList,
            method: "get",
            data: {
              store_id: Store.fetch().store_id,
            },
          })
          .then((res) => {
            if (res.code == 0) {
              this.pickShelves = res.data;
            }
          });
      }
    },
    arrive_time_count(date1) {
      var date1 = date1;
      var date2 = new Date();
      var date3 = date2.getTime() - new Date(date1).getTime();
      var subMinutes = Math.floor(date3 / (60 * 1000));
      var days = Math.floor(date3 / (24 * 3600 * 1000));
      var leave1 = date3 % (24 * 3600 * 1000);
      var hours = Math.floor(leave1 / (3600 * 1000));
      var leave2 = leave1 % (3600 * 1000);
      var minutes = Math.floor(leave2 / (60 * 1000));
      var leave3 = leave2 % (60 * 1000);
      var seconds = Math.round(leave3 / 1000);
      return days;
    },
    handleStoreChange(index) {
      this.$refs.resetSelect.clearSingleSelect();
      this.getShelvesList(index);
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;
      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "get",
          data: {
            status: -4,
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            arrive: form.arrive,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            odd_numbers: form.odd_numbers,
            phone: form.phone,
            macao_originating: 1,
            sack_number: form.sack_number,
            username: form.username,
            pay_type: form.pay_type,
            arrive_code: form.shelves,
            admin_id: form.admin_id,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let class_temp = [];
            let class_pay_type = [];
            let resData = res.data.data;
            this.weight = 0;

            for (let i = 0; i < resData.length; i++) {
              let integral_tw = 0;
              if (resData[i].user != null) {
                for (let j = 0; j < resData[i].user.tw.length; j++) {
                  let integral_tw_count = Number(
                    resData[i].user.tw[j].integral
                  );
                  integral_tw += integral_tw_count;
                }
              }

              if (resData[i].pay_type == 0) {
                class_pay_type[i] = "";
              } else {
                class_pay_type[i] = "demo-table-app-row";
              }

              if (
                this.arrive_time_count(resData[i].arrive_time) >= 7 &&
                resData[i].arrive_time != null
              ) {
                class_temp[i] = "demo-table-info-row";
              } else if (
                this.arrive_time_count(resData[i].arrive_time) >= 2 &&
                resData[i].arrive_time != null
              ) {
                class_temp[i] = "demo-table-error-row";
              } else {
                class_temp[i] = "";
              }

              tempArr.push({
                id: resData[i].id,

                volume_weight: resData[i].volume_weight,

                weight: resData[i].weight,

                admininfo:
                  resData[i].admininfo == null
                    ? "- - -"
                    : resData[i].admininfo.realname,

                user_id:
                  resData[i].user == null ? "- - -" : resData[i].user.user_id,

                recipient_contacts:
                  resData[i].user == null
                    ? resData[i].recipient_contacts
                    : resData[i].recipient_contacts +
                      "【" +
                      (resData[i].user.user_integral + integral_tw) +
                      "】", //客戶名稱【積分】

                recipient_phone: resData[i].recipient_phone, //客戶電話

                odd_numbers: resData[i].odd_numbers, //出貨單號

                shelves:
                  resData[i].shelves == null
                    ? "- - -"
                    : resData[i].shelves.code, //貨架號

                pay_type:
                  resData[i].pay_type == 0 ? "未在APP內付款" : "已在APP內付款", //付款状况

                sum:
                  Number(resData[i].amount) +
                  Number(resData[i].freight_collect) +
                  Number(resData[i].surcharge_price) +
                  Number(resData[i].outtimepays || 0) -
                  Number(
                    resData[i].store == null ? 0 : resData[i].store.activity
                  ), //合計費用

                freight_collect: Number(resData[i].freight_collect), // 到付運費

                surcharge_price: Number(resData[i].surcharge_price), // 加收附加費

                outtimepay: resData[i].outtimepays ? resData[i].outtimepays : 0, //超期費

                amount: Number(resData[i].amount), // 代收費

                activity:
                  resData[i].store == null
                    ? 0
                    : "-" + resData[i].store.activity, // 門店立減費

                receivingName:
                  resData[i].store == null
                    ? "- - -"
                    : resData[i].store.ReceivingName, //取貨櫃點

                sack_number:
                  resData[i].sack_number == null
                    ? "- - -"
                    : resData[i].sack_number, //袋號

                productName: resData[i].detailed.name, //品名

                in_time:
                  resData[i].in_time == null ? "- - -" : resData[i].in_time,

                out_time:
                  resData[i].out_time == null ? "- - -" : resData[i].out_time,

                macao_originating_time:
                  resData[i].macao_originating_time == null
                    ? "- - -"
                    : resData[i].macao_originating_time,

                macao_originating_out_time:
                  resData[i].macao_originating_out_time == null
                    ? "- - -"
                    : resData[i].macao_originating_out_time,

                arrive_time:
                  resData[i].arrive_time == null
                    ? "- - -"
                    : resData[i].arrive_time, // 到店時間

                pick_time:
                  resData[i].pick_time == null ? "- - -" : resData[i].pick_time,

                remarks:
                  resData[i].remarks == null ? "- - -" : resData[i].remarks, //備註

                save_time:
                  resData[i].arrive_time == null
                    ? "- - -"
                    : this.arrive_time_count(resData[i].arrive_time),
                cellClassName: {
                  //記錄
                  save_time: class_temp[i],
                  pay_type: class_pay_type[i],
                },
              });
            }
            this.totalCount = res.data.count;
            this.table.data = tempArr;
          } else {
            this.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
    handleEdit(index) {
      let tableData = this.table.data;
      this.$router.push({ path: "/deliveredEdit?id=" + tableData[index].id });
    },
    handleViewRemark(index) {
      let tableData = this.table.data;
      this.$router.push({
        path: "/shopSignetodoRemark?id=" + tableData[index].id,
      });
    },
    handleViewWuliu(index) {
      let tableData = this.table.data;
      this.$router.push({
        path:
          "/shopSigntodologisticsInfo?orderNo=" + tableData[index].odd_numbers,
      });
    },
    handleIntegral(index) {
      let tableData = this.table.data;
      this.$router.push({
        path: "/shopUserIntegral?id=" + tableData[index].user_id,
      });
    },
    handleSearch() {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },
    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },
    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.floor(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      isthis.sums = 0;
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      isthis.sums = 0;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      isthis.sums = 0;
      this.getList();
    },
    handleSelectionChange() {
      let weight = 0,
        price = 0;
      this.curCheckedList = this.$refs.table.getSelection();
      this.curCheckedList.forEach((item) => {
        weight += parseFloat(item.weight);
        price += parseFloat(item.sum);
      });
      isthis.sums = this.curCheckedList.length;
      isthis.weight = weight.toFixed(2);
      isthis.price = price.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "signedtochange.scss";
</style>
<style>
.ivu-table td.demo-table-info-column {
  background-color: #ffebde;
  color: #000;
}

.ivu-table td.demo-table-info-cell-name {
  background-color: #d6e7ff;
  color: #515a6e;
}

.ivu-table td.demo-table-info-cell-name-sum {
  background-color: #ffebde;
  color: #000;
}

.ivu-table .demo-table-error-row {
  background-color: #fcffd6;
  color: #515a6e;
}

.ivu-table .demo-table-info-row {
  background-color: #ffebde;
  color: #515a6e;
}

.ivu-table .demo-table-app-row {
  background-color: #e8ffd6;
  color: #515a6e;
}
</style>
